export default {
  MAX_LONG: 999999999999999999,
  MIN_LONG: -999999999999999999,
  MAX_DECIMAL: 99999999999999.94,
  MIN_DECIMAL: -99999999999999.94,
  MAX_INTEGER: 2147483647,
  MIN_INTEGER: -2147483647,
  MAX_SHORT: 32767,
  MIN_SHORT: -32767,
  MAX_BYTE: 127,
  MIN_BYTE: -128
};
